import { render, staticRenderFns } from "./SynologyDownload.vue?vue&type=template&id=1a609a94&scoped=true"
import script from "./SynologyDownload.vue?vue&type=script&lang=js"
export * from "./SynologyDownload.vue?vue&type=script&lang=js"
import style0 from "./SynologyDownload.vue?vue&type=style&index=0&id=1a609a94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a609a94",
  null
  
)

export default component.exports